import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export interface VehicleRow {
  vehicleId: string;
  plate: string;
  brand: string | null;
  model: string | null;
  active: boolean;
  fuelingCents: number;
  fuelingCount: number;
  fuelingLiters: number;
  maintenanceCents: number;
  maintenanceCount: number;
  finesCents: number;
  finesCount: number;
  totalCents: number;
}

export interface FinancialClosingResponse {
  data: {
    period: { fromDate: string; toDate: string };
    tenantId: string;
    totals: {
      fuelingCents: number;
      fuelingCount: number;
      fuelingLiters: number;
      maintenanceCents: number;
      maintenanceCount: number;
      finesCents: number;
      finesCount: number;
      totalCents: number;
    };
    byVehicle: VehicleRow[];
  };
}

export function useFinancialClosing(params: {
  fromDate?: string;
  toDate?: string;
  vehicleId?: string;
}) {
  return useQuery({
    queryKey: ['reports', 'financial-closing', params],
    queryFn: async () => {
      const { data } = await api.get<FinancialClosingResponse>(
        '/reports/financial-closing',
        { params },
      );
      return data.data;
    },
  });
}
